import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost} from '../../util/util'

export const getActivityLog = createAsyncThunk(
	'getActivityLog',
	async ()=> await envAwarePost(
		'api/notifications/api',
		{action:'getActivityLog'}
	)
)

export const reactInBulk = createAsyncThunk(
	'reactInBulk',
	async (reaction_id) => await envAwarePost(
		'api/notifications/',
		{actions:['reactInBulk','getActivityLog'],reaction_id}
	)
)

//uses two actions: one to clear and one to fetch log after clearing
export const clearAllNotifications = createAsyncThunk(
	'clearAllNotifications',
	async ()=>await envAwarePost(
		'api/notifications/',
		{actions:['clearAllNotifications','getActivityLog']}
	)
)

//uses two actions: one to remove and one to fetch log after remove
export const removeNotification = createAsyncThunk(
	'removeNotification',
	async notification_id=> await envAwarePost(
		'api/notifications/',
		{actions:['removeNotification','getActivityLog'],notification_id}
	)
)

const slice = createSlice({
	name: 'messenger',
	initialState:{sections:[]},
	reducers: {},
	extraReducers:{
		[getActivityLog.fulfilled] : (state,action) => {
			console.log(action.payload.data);
			state.sections = action.payload.data.activity_sections
		},
		[clearAllNotifications.fulfilled] : (state,action) => {
			state.sections = action.payload.getActivityLog.data.activity_sections
		},
		[reactInBulk.fulfilled] : (state,action) => {
			state.sections = action.payload.getActivityLog.data.activity_sections
		},
		[removeNotification.fulfilled] : (state,action) => {
			state.sections = action.payload.getActivityLog.data.activity_sections
		}
	}
})

export default slice.reducer